export const useCurrentYearMonth = (timestamp?: number) => {
  const date = timestamp ? new Date(timestamp) : new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed in JavaScript, so we add 1
  return `${year}-${month}`;
};
